import React from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import WebsitesSubmenu from './WebsitesSubmenu';
import APIMonitoringSubmenu from './APIMonitoringSubmenu';
import PeopleSubmenu from './PeopleSubmenu';
import BillingSubmenu from './BillingSubmenu';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();

  const shouldShowWebsitesSubmenu = location.pathname === '/analytics' || location.pathname === '/blog';
  const shouldShowAPISubmenu = location.pathname.startsWith('/api-monitoring');
  const shouldShowPeopleSubmenu = location.pathname === '/users' || location.pathname === '/companies';
  const shouldShowBillingSubmenu = location.pathname.startsWith('/billing');

  return (
    <>
      <Sidebar />
      {shouldShowWebsitesSubmenu && <WebsitesSubmenu />}
      {shouldShowAPISubmenu && <APIMonitoringSubmenu />}
      {shouldShowPeopleSubmenu && <PeopleSubmenu />}
      {shouldShowBillingSubmenu && <BillingSubmenu />}
      {children}
    </>
  );
};

export default Layout; 